import { CheckErrorVisibilityInterface, SetValueInterface } from "commons/types/form";

import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import AutosizeTextarea from "commons/ui/input/AutosizeTextarea";
import InputText from "commons/ui/input/InputText";

import TwoLanguagesAdornment from "components/subComponents/TwoLanguagesAdornment";

import { LanguageEnum, MetaFields } from "types/api/commons";

type PropsType = {
    text: MetaFields;
    setValue: SetValueInterface;
    checkErrorVisibility: CheckErrorVisibilityInterface;
    path?: string;
};

function MetaFieldsForm({ text, setValue, checkErrorVisibility, path = "text" }: PropsType) {
    return (
        <GridColumn>
            <GridRow className={"title-margin"}>
                <GridItem>
                    <h2>SEO Italiano</h2>
                </GridItem>
            </GridRow>

            <GridRow>
                <GridItem className={"col-xs-12-12"}>
                    <InputText
                        label={"Meta Titolo"}
                        startAdornment={TwoLanguagesAdornment("it")}
                        setValue={setValue}
                        value={text[LanguageEnum.it].meta_title}
                        path={`${path}.${LanguageEnum.it}.meta_title`}
                        checkErrorVisibility={checkErrorVisibility}
                    />
                </GridItem>
            </GridRow>

            <GridRow>
                <GridItem className={"col-xs-12-12"}>
                    <AutosizeTextarea
                        label={"Meta Descrizione"}
                        value={text[LanguageEnum.it].meta_description}
                        path={`${path}.${LanguageEnum.it}.meta_description`}
                        setValue={setValue}
                        checkErrorVisibility={checkErrorVisibility}
                    />
                </GridItem>
            </GridRow>

            <GridRow>
                <GridItem className={"col-xs-12-12"}>
                    <AutosizeTextarea
                        label={"Meta keywords"}
                        setValue={setValue}
                        value={text[LanguageEnum.it].meta_keywords}
                        path={`${path}.${LanguageEnum.it}.meta_keywords`}
                        checkErrorVisibility={checkErrorVisibility}
                    />
                </GridItem>
            </GridRow>

            <GridRow className={"title-margin"}>
                <GridItem>
                    <h2>SEO Inglese</h2>
                </GridItem>
            </GridRow>

            <GridRow>
                <GridItem className={"col-xs-12-12"}>
                    <InputText
                        label={"Meta Titolo"}
                        startAdornment={TwoLanguagesAdornment("en")}
                        setValue={setValue}
                        value={text[LanguageEnum.en].meta_title}
                        path={`${path}.${LanguageEnum.en}.meta_title`}
                        checkErrorVisibility={checkErrorVisibility}
                    />
                </GridItem>
            </GridRow>

            <GridRow>
                <GridItem className={"col-xs-12-12"}>
                    <AutosizeTextarea
                        label={"Meta Descrizione"}
                        value={text[LanguageEnum.en].meta_description}
                        path={`${path}.${LanguageEnum.en}.meta_description`}
                        setValue={setValue}
                        checkErrorVisibility={checkErrorVisibility}
                    />
                </GridItem>
            </GridRow>

            <GridRow>
                <GridItem className={"col-xs-12-12"}>
                    <AutosizeTextarea
                        label={"Meta keywords"}
                        setValue={setValue}
                        value={text[LanguageEnum.en].meta_keywords}
                        path={`${path}.${LanguageEnum.en}.meta_keywords`}
                        checkErrorVisibility={checkErrorVisibility}
                    />
                </GridItem>
            </GridRow>
        </GridColumn>
    );
}

export default MetaFieldsForm;
